<!--
  Copyright 2026 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<button
  mat-icon-button
  [matMenuTriggerFor]="languageMenu"
  i18n-aria-label="@@app.labels.changeLanguage"
  aria-label="Change language"
>
  <mat-icon>translate</mat-icon>
</button>

<mat-menu #languageMenu="matMenu">
  @for (language of languages; track language.code) {
    <button
      mat-menu-item
      [attr.lang]="language.code"
      [disabled]="language.code === currentLanguageCode"
      (click)="onLanguageClick(language.code)"
    >
      {{ language.name }}
    </button>
  }
</mat-menu>
